import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { loaders, invoiceStatusConfig } from 'entities';

import {
  SendIcon,
  ReceiptLongIcon,
  DollarBillIcon,
  CircleCheckIcon,
  CircleXIcon,
  CircleDollarIcon,
} from 'components/Icons';

import { CardGrid } from './CardGrid';
import ReadyToCreate from './ReadyToCreate';

// if we use this elsewhere, we need to put it inside the config, probably tie the colors there too.
const iconMapping: Record<string, ReactNode> = {
  [invoiceStatusConfig.invoiced.code]: <ReceiptLongIcon color="#0695fd" />,

  [invoiceStatusConfig.paid.code]: <DollarBillIcon color="#19c29b" />,

  [invoiceStatusConfig.readyToSendToAccountant.code]: <CircleCheckIcon color="#b664f3" />,

  [invoiceStatusConfig.sentToAccountant.code]: <SendIcon color="#d836c1" />,

  [invoiceStatusConfig.canceled.code]: <CircleXIcon color="#e47474" />,
};

export function Invoices(): JSX.Element {
  const { t } = useLang();

  const { data, errorOrLoading } = loaders.invoice.invoiceCounts.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'INVOICE_COUNTS',

      onMessage: ({ counts }) => counts,
    },
  });

  return (
    <CardGrid
      title={t('invoices')}
      icon={<CircleDollarIcon />}
      loading={errorOrLoading}
      items={Object.values(invoiceStatusConfig).map(({ getLabel, code, queryParam }) => ({
        getLabel,
        to: 'invoices',
        params: { status: queryParam },
        icon: iconMapping[code],
        count: data[code] ?? 0,
      }))}
    >
      <ReadyToCreate />
    </CardGrid>
  );
}
